import { StyleSheet } from 'react-native';
import { modalExperience } from '../../shared/modals/modalExperience.styles';
import { spacing, ticketColors, ticketFonts, typography } from '../../shared/theme/public-api';

export const posOperationalAlertsStyles = StyleSheet.create({
  band: {
    gap: spacing.sm,
    marginBottom: spacing.sm,
  },
  readyCard: {
    ...modalExperience.heroBand,
    alignItems: 'center',
    borderColor: ticketColors.brandSoft,
    backgroundColor: ticketColors.paper,
  },
  readyRow: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: spacing.sm,
    minWidth: 0,
  },
  readyIcon: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: '#15803D',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  readyCopy: {
    flex: 1,
    minWidth: 0,
    gap: 2,
    paddingTop: 2,
  },
  readyKicker: {
    ...modalExperience.heroKicker,
    color: ticketColors.ink3,
  },
  readyTitle: {
    fontSize: 15,
    fontWeight: '700',
    color: ticketColors.ink,
    lineHeight: 20,
    letterSpacing: -0.2,
    fontFamily: ticketFonts.sans,
  },
  dismissBtn: {
    paddingVertical: spacing.xs,
    paddingHorizontal: spacing.sm,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
  },
  dismissLabel: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '700',
    fontFamily: ticketFonts.sans,
  },
  mpqrCard: {
    ...modalExperience.warningPanel,
  },
  mpqrText: {
    ...typography.body,
    fontSize: 14,
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  mpqrLink: {
    ...typography.caption,
    color: ticketColors.goldInk,
    fontWeight: '700',
    fontFamily: ticketFonts.sans,
  },
});
